export const isUnauthError = (error) => {
  return error?.response?.status === 401;
};
